import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeVideoPlugin from 'photoswipe-video-plugin';

/**
 * Load PhotoSwipe gallery
 */
class photoSwipe extends HTMLElement {
  /**
   * connectedCallback
   */
  connectedCallback() {
    const gallery = this.getAttribute('gallery');
    const children = this.getAttribute('children');

    const lightbox = new PhotoSwipeLightbox({
      gallery,
      children,
      pswpModule: PhotoSwipe,
      showHideAnimationType: 'fade',
    });

    // eslint-disable-next-line
    const videoPlugin = new PhotoSwipeVideoPlugin(lightbox, {});

    lightbox.init();
  }
}

customElements.define('photo-swipe', photoSwipe);
